module.exports = __webpack_public_path__ + "img/configure-benefits.af363243.svg";